
import { StrategyStatsProps } from '../types/strategy-card-types';
import InfoTooltip from '@/components/ui/info-tooltip';

const StrategyStats = ({ 
  winRate, 
  maxDrawdown, 
  tradesWon, 
  tradesLost,
  aum,
  pnlRatio,
  timespan,
  isPro = false,
  infoIconColor = "#555555"
}: StrategyStatsProps) => {
  // Only calculate win/lose ratio if both values are available
  const winLoseRatio = tradesWon !== null && tradesLost !== null && tradesWon !== undefined && tradesLost !== undefined 
    ? tradesWon / (tradesWon + tradesLost) * 100 
    : null;
  
  // Use higher contrast text colors for regular theme
  const valueClasses = 'text-[#012846] font-semibold';
  const labelClasses = 'text-gray-600 font-medium';
  
  // Special classes for Phemex landing page dark theme
  const phemexValueClasses = 'text-white font-semibold';
  const phemexLabelClasses = 'text-gray-200 font-medium';
  
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2 mt-2 mb-3">
      {winRate !== null && winRate !== undefined && (
        <>
          <div className="phemex-stat-text phemex-stat-value">
            <span className={`phemex-landing-card ${valueClasses}`}>{winRate.toFixed(0)}%</span>
            <span className={`ml-1 phemex-landing-card ${labelClasses}`}>Win Rate</span>
            <InfoTooltip 
              content="Shows the average win rate of a Master Trader over a certain period." 
              side="top"
              className="text-white/80 hover:text-white"
              infoIconColor={infoIconColor}
            />
          </div>
          {maxDrawdown !== null && maxDrawdown !== undefined && (
            <div className="phemex-stat-text phemex-stat-value">
              <span className={`phemex-landing-card ${valueClasses}`}>{maxDrawdown.toFixed(1)}%</span>
              <span className={`ml-1 phemex-landing-card ${labelClasses}`}>MDD</span>
              <InfoTooltip 
                content="A low Maximum Drawdown indicates that the unrealized losses from a Master Trader's trading strategy has been relatively small." 
                side="top"
                className="text-white/80 hover:text-white"
                infoIconColor={infoIconColor}
              />
            </div>
          )}
        </>
      )}
      
      {tradesWon !== null && tradesLost !== null && tradesWon !== undefined && tradesLost !== undefined && (
        <>
          <div className="phemex-stat-text phemex-stat-value">
            <span className={`phemex-landing-card ${valueClasses}`}>{tradesWon}</span>
            <span className={`ml-1 phemex-landing-card ${labelClasses}`}>Trades Won</span>
          </div>
          <div className="phemex-stat-text phemex-stat-value">
            <span className={`phemex-landing-card ${valueClasses}`}>{tradesLost}</span>
            <span className={`ml-1 phemex-landing-card ${labelClasses}`}>Trades Lost</span>
          </div>
        </>
      )}
      
      {aum !== null && aum !== undefined && (
        <div className="phemex-stat-text phemex-stat-value">
          <span className={`phemex-landing-card ${valueClasses}`}>${aum.toLocaleString()}</span>
          <span className={`ml-1 phemex-landing-card ${labelClasses}`}>AUM</span>
          <InfoTooltip 
            content="Assets under management" 
            side="top"
            className="text-white/80 hover:text-white"
            infoIconColor={infoIconColor}
          />
        </div>
      )}
      
      {/* We only show this if we don't have more detailed stats */}
      {!winRate && !tradesWon && winLoseRatio !== null && (
        <div className="phemex-stat-text phemex-stat-value">
          <span className={`phemex-landing-card ${valueClasses}`}>{winLoseRatio.toFixed(0)}%</span>
          <span className={`ml-1 phemex-landing-card ${labelClasses}`}>Success Rate</span>
          <InfoTooltip 
            content="The percentage of successful trades relative to the total number of trades." 
            side="top"
            className="text-white/80 hover:text-white"
            infoIconColor={infoIconColor}
          />
        </div>
      )}
    </div>
  );
};

export default StrategyStats;
